/* Lightening Beauty - Theme JS */

window.theme = window.theme || {};

theme.Animation = (function() {
  function init() {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in-up').forEach(el => {
      observer.observe(el);
    });
  }

  return { init: init };
})();

document.addEventListener('DOMContentLoaded', () => {
  theme.Animation.init();
});
